import { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles/checkoutTextWithTooltip.scss';

// components
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import { Link } from 'dibs-elements/exports/Link';
import CircleQuestionMarkEmptyIcon from 'dibs-icons/exports/legacy/CircleQuestionMarkEmpty';
import CircleQuestionMarkFilledIcon from 'dibs-icons/exports/legacy/CircleQuestionMarkFilled';
import CloseIcon from 'dibs-icons/exports/legacy/Close';

class CheckoutTextWithTooltip extends Component {
    constructor(props) {
        super(props);
        this.onCloseTooltip = this.onCloseTooltip.bind(this);
        this.onOpenTooltip = this.onOpenTooltip.bind(this);
        this.state = {
            isVisible: false,
        };
    }
    componentDidMount() {
        if (!this.props.showOnScroll) {
            window.addEventListener('scroll', this.onCloseTooltip);
        }
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isVisible && this.props.isVisible) {
            this.onOpenTooltip();
        }
    }
    componentWillUnmount() {
        if (!this.props.showOnScroll) {
            window.removeEventListener('scroll', this.onCloseTooltip);
        }
    }
    onCloseTooltip() {
        this.setState({ isVisible: false });
    }
    onOpenTooltip() {
        this.setState({ isVisible: true });
    }
    renderTooltip() {
        const { tooltip, customTooltipSize } = this.props;
        return (
            <Tooltip
                type={customTooltipSize ? customTooltipSize : 'large'}
                direction="right"
                align={this.props.alignTooltip || 'center'}
                isVisible={this.state.isVisible}
                closeOnOutsideClick
                onClose={this.onCloseTooltip}
            >
                <Link className={styles.closeIcon} onClick={this.onCloseTooltip}>
                    <CloseIcon />
                </Link>
                {typeof tooltip === 'function'
                    ? tooltip({ isVisible: this.state.isVisible })
                    : tooltip}
            </Tooltip>
        );
    }
    render() {
        const { isVisible } = this.state;
        const {
            wrapperClass,
            text,
            addQuestionMark,
            questionMarkClass,
            questionMarkIconClass,
            dataTn,
        } = this.props;
        const toggleHandlerProps = {
            onClick: this.onOpenTooltip,
        };
        return (
            <span className={classNames(styles.wrapper, wrapperClass)} data-tn={dataTn}>
                <div
                    className={addQuestionMark ? styles.inline : styles.block}
                    {...(addQuestionMark ? {} : toggleHandlerProps)}
                >
                    {text}
                    {addQuestionMark ? (
                        <span
                            className={classNames(styles.tooltipWrapper, questionMarkClass)}
                            {...toggleHandlerProps}
                        >
                            <div className={styles.questionWrapper}>
                                {isVisible ? (
                                    <CircleQuestionMarkFilledIcon
                                        className={classNames(
                                            styles.questionIcon,
                                            questionMarkIconClass
                                        )}
                                    />
                                ) : (
                                    <CircleQuestionMarkEmptyIcon
                                        className={classNames(
                                            styles.questionIcon,
                                            questionMarkIconClass
                                        )}
                                    />
                                )}
                            </div>
                            {this.renderTooltip()}
                        </span>
                    ) : (
                        this.renderTooltip()
                    )}
                </div>
            </span>
        );
    }
}

CheckoutTextWithTooltip.propTypes = {
    wrapperClass: PropTypes.string,
    text: PropTypes.node,
    tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    showOnScroll: PropTypes.bool,
    addQuestionMark: PropTypes.bool,
    alignTooltip: PropTypes.string,
    onTooltip: PropTypes.func,
    isVisible: PropTypes.bool,
    questionMarkClass: PropTypes.string,
    questionMarkIconClass: PropTypes.string,
    dataTn: PropTypes.string,
    customTooltipSize: PropTypes.string,
};

CheckoutTextWithTooltip.defaultProps = {
    wrapperClass: '',
    text: '',
    tooltip: '',
    showOnScroll: false,
    addQuestionMark: false,
    dataTn: 'checkout-tooltip',
};

export default CheckoutTextWithTooltip;
